module.exports = "https://static.wmbcdn.com/uniweb/images/ccc33aa35c6dfd4db7e5978e4b1fac56.svg";